import "./selectplanmobile.scss";
import config from "../../app.json";
import axios from "axios";

import { Form, Row, Col } from "react-bootstrap";
import { Context } from "../../Reducers/Store";
import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import Bolt from "../../Assets/Images/zap.svg";
import MonkeyFace from "../../Assets/Images/monkey-face.svg"
import Nope from "../../Assets/Images/nope.svg"
import NormalCheck from "../../Assets/Images/check.svg"
import CheckSpecial from "../../Assets/Images/check-special.svg"


import Image from "../Image/image";
import PlanOption from "../PlanOption/planoption";
import Toggle from "react-toggle";

const SelectPlanMobile = (props) => {
  const { selectPlanMobile, setSelectPlanMobile } = props;
  const [state, dispatch] = useContext(Context);
  const [allPlans, setAllPlans] = useState([]);
  const [periodicity, setPeriodicity] = useState("mo");
  const [myPlan, setMyPlan] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [currentPlanActive, setCurrentPlanActive] = useState(false);
  const [myPlanMonthlyPrice, setMyPlanMonthlyPrice] = useState(null);
  const [toggleMonthly, setToggleMonthly] = useState(false);
  const [jwtMobile, setJwtMobile] = useState(null);

  useEffect(() => {
    dispatch({ type: "SET_LOADING", payload: true });

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const jwt = urlParams.get("jwt");
    setJwtMobile(jwt);

    dispatch({ type: "SET_LOGGED", payload: { token: jwt, refreshToken: null } });
  }, [0]);

  useEffect(() => {
    if (!state.jwt)
    return;
    const optionsGet = {
      headers: { Authorization: "Bearer " + state.jwt },
    };

    axios.get(config.API_HM + "/subscriptions/plans", optionsGet).then((result) => {
      const currentPlan = result.data.filter((x) => x.name === myPlan)?.at(0);
      const monthlyPrice = currentPlan?.prices.filter((x) => x.periodicity === "Monthly")?.at(0)?.value ?? 0;
      setMyPlanMonthlyPrice(monthlyPrice);
      setAllPlans(result.data);
    });

    axios
      .get(config.API_HM + "/profile")
      .then((result) => {
        if (!result.data?.subscription) {
          axios
            .post(config.API_HM + "/subscriptions/invitations/accept", {})
            .then((resultSub) => {
              if (resultSub.status === 200) {
                axios.get(config.API_HM + "/profile").then((result) => {
                  dispatch({ type: "SET_PROFILE", payload: result.data });
                });
              } else {
                setLoaded(true);
              }
            })
            .catch(() => {
              setLoaded(true);
            });
        } else {
          dispatch({ type: "SET_PROFILE", payload: result.data });
          setLoaded(true);
        }

        setMyPlan(result.data?.subscription?.plan);
        setCurrentPlanActive(result.data?.subscription?.active);
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
  }, [state.jwt]);

  useEffect(() => {
    if (state.profile) {
      axios.get(config.API_HM + "/subscriptions/plans").then((result) => {
        const currentPlan = result.data.filter((x) => x.name === myPlan)?.at(0);
        const monthlyPrice = currentPlan?.prices.filter((x) => x.periodicity === "Monthly")?.at(0)?.value ?? 0;
        setMyPlanMonthlyPrice(monthlyPrice);
        setAllPlans(result.data);
      });
    }
  }, [state.profile]);

  // const handleOptionChange = (event) => {
  //   setPeriodicity(event.target.value);
  // };

  const handleOptionChangeToggle = () => {
    const monthly = periodicity === `mo`;
    const newValue = monthly ? `yr` : `mo`;
    setPeriodicity(newValue);
  };

  const handleNotifications = () => {
    setToggleMonthly(!toggleMonthly);
    handleOptionChangeToggle();
  };

  const anyZeroPlan = allPlans?.some((x) => x.prices?.some((y) => y.value === 0));
  const planColumnsSize = allPlans != null && allPlans.length > 0 ? Math.floor(12 / allPlans.length) : 4;
  return loaded ? (
    <div className={`plan-container  ${selectPlanMobile ? `select-plan` : ``} mobile-plan-top`}>
      <div className={`logo-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12">
            <Image src={MonkeyFace} width={50} height={50} />
          </Col>
        </Row>
      </div>
      <div className={`header-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12 modile-plan-header">
            <h6 className="mobile-plan-title">Say hello to affordable AI with pricing plans for every budget.</h6>
            <p>Try Socialchimp for 7 days for <span>FREE</span> <br />
            Cancel any time.</p>
          </Col>
        </Row>
      </div>
      <div>
        <Row className="d-flex justify-content-center">
          <div className="notifications-column">
            <div className="form-group">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span className="monthly-text">Monthly</span>
                <Toggle checked={toggleMonthly} onClick={handleNotifications} className="form-group" icons={false} />
                <span className="yearly-text">Yearly <small>Save 11%</small></span>
              </div>
            </div>
          </div>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col md={8} className="align-self-center">
            <Row>
              <Col className="col-md-12">
                <Row className="gx-0 plans-row">
                  {allPlans?.map((x, index) => {
                    return (
                      <div className={`col-md-${planColumnsSize}`} key={"item_plan_" + index + "_" + x.id}>
                        <PlanOption
                          {...x}
                          freeTrialDays={x.freeTrialDays != null && x.freeTrialDays != undefined ? x.freeTrialDays : 0}
                          periodicity={periodicity}
                          selectPlan={true}
                          currentPlan={false}
                          bestOption={x.popular}
                          jwtMobile={jwtMobile}
                        />
                      </div>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center features-list" style={{ paddingTop: "32px" }}>
          <Col md={12}>
            <ul className="list-header">
              <li className="head">
                <div className="table-header">
                  <Image src={MonkeyFace} width={24} height={24} />
                  <h6 >Socialchimp Features</h6>
                </div>
              </li>
              <li className="type special">
              <Image src={Bolt} width={18} height={18} />Pro
              </li>
              <li className="type">
                Base
              </li>
            </ul>

            <ul className="list-item">
              <li className="head">
              Unlimited AI content generation
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
                <Image src={NormalCheck} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Documentation access
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
                <Image src={NormalCheck} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Enterprise-level support
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
                <Image src={NormalCheck} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Customizable AI prompts
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
                <Image src={Nope} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Dedicated account manager
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
              <Image src={Nope} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Full API integration
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
              <Image src={Nope} width={18} height={18} />
              </li>
            </ul>
            <ul className="list-item">
              <li className="head">
              Turbo AI generation
              </li>
              <li className="check">
                <Image src={CheckSpecial} width={18} height={18} />
              </li>
              <li className="check">
              <Image src={Nope} width={18} height={18} />
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  ) : null;
};
export default SelectPlanMobile;
